"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHistoryOperation = void 0;
var common_core_1 = require("@moralisweb3/common-core");
exports.getHistoryOperation = {
    method: 'GET',
    name: 'getHistory',
    id: 'GetHistory',
    groupName: 'history',
    urlPathPattern: '/history',
    urlSearchParamNames: ['excludePayload', 'limit', 'cursor'],
    firstPageIndex: 0,
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        excludePayload: (0, common_core_1.maybe)(request.excludePayload, String),
        limit: (0, common_core_1.maybe)(request.limit, String),
        cursor: request.cursor,
    };
}
function deserializeResponse(jsonResponse) {
    var _a;
    return (_a = jsonResponse.result) !== null && _a !== void 0 ? _a : [];
}
function serializeRequest(request) {
    return request;
}
function deserializeRequest(jsonRequest) {
    return jsonRequest;
}
//# sourceMappingURL=getHistoryOperation.js.map